import { render, staticRenderFns } from "./Portlet.vue?vue&type=template&id=452f4f1c&scoped=true&"
import script from "./Portlet.vue?vue&type=script&lang=js&"
export * from "./Portlet.vue?vue&type=script&lang=js&"
import style0 from "./Portlet.vue?vue&type=style&index=0&id=452f4f1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452f4f1c",
  null
  
)

export default component.exports